import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_NEED_MORE_INFO } from '@shared/components/project-discussion/service/project-discussion.service.constants';
import { IProjectDiscussionGetCommentsResponse } from '@shared/components/project-discussion/service/project-discussion.service.types';
import { IProject } from '@shared/services/project.service.types';

@Component({
  selector: 'app-project-discussion-chat',
  templateUrl: './project-discussion-chat.component.html',
  styleUrls: ['./project-discussion-chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDiscussionChatComponent {
  @Input() comments: IProjectDiscussionGetCommentsResponse;
  @Input() project: IProject;

  readonly projectDiscussionCommentContentTypeNeedMoreInfo = PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_NEED_MORE_INFO;
}
